var createStylesheet = function(chunkId, fullhref, resolve, reject) {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = function(event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	2143: 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"1":1,"79":1,"131":1,"132":1,"223":1,"258":1,"467":1,"499":1,"657":1,"857":1,"926":1,"1104":1,"1193":1,"1212":1,"1368":1,"1419":1,"1483":1,"1492":1,"1521":1,"1550":1,"1628":1,"1825":1,"2052":1,"2270":1,"2305":1,"2315":1,"2586":1,"2715":1,"2931":1,"2996":1,"3338":1,"3367":1,"3483":1,"3517":1,"3580":1,"3591":1,"3618":1,"3643":1,"3806":1,"3824":1,"4158":1,"4174":1,"4190":1,"4204":1,"4437":1,"4628":1,"4718":1,"4871":1,"5112":1,"5129":1,"5211":1,"5239":1,"5287":1,"5427":1,"5443":1,"5617":1,"5696":1,"5867":1,"5875":1,"6109":1,"6178":1,"6290":1,"6318":1,"6381":1,"6647":1,"6977":1,"7166":1,"7368":1,"7401":1,"7409":1,"7683":1,"7708":1,"7737":1,"7739":1,"7967":1,"8107":1,"8371":1,"8547":1,"8685":1,"8760":1,"8829":1,"9163":1,"9503":1,"9637":1,"9764":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr